// Jun-2026 — BOQ Vendor PO: shared banner showing the uniform client-rate
// deduction so PO makers AND approvers see Client Rate → PO Rate per line.
export const BoqPoDeductionNote = ({ po }) => {
  const meta = po?.boq_po_meta;
  if (!meta || po?.po_origin !== "BOQ_DIRECT") return null;
  const lines = (po.line_items || []).filter((l) => l.line_origin === "BOQ_DIRECT");
  const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;
  return (
    <div className="mt-1.5 border border-violet-300 bg-violet-50 rounded px-3 py-2 text-[11px] text-violet-900" data-testid="boqpo-deduction-note">
      <div className="font-bold">
        BOQ Vendor PO — mirrors Approved BOQ {meta.boq_number || ""}{meta.version_number != null ? ` (V${meta.version_number})` : ""} ·
        every client rate uniformly reduced by <span className="text-violet-950 text-xs" data-testid="boqpo-deduction-pct">{meta.deduction_percent}%</span> ·
        GST {meta.gst_enabled ? "as per BOQ line tax %" : "disabled"} · service items — no GRN, PI-ready on approval
      </div>
      {lines.length > 0 && (
        <details className="mt-1">
          <summary className="cursor-pointer font-bold text-violet-700 hover:underline" data-testid="boqpo-rates-toggle">
            Client Rate → PO Rate ({lines.length} line{lines.length === 1 ? "" : "s"})
          </summary>
          <table className="mt-1 w-full max-w-xl text-[10px]">
            <thead>
              <tr className="text-left uppercase text-violet-500">
                <th className="pr-2 py-0.5">Code</th><th className="pr-2 py-0.5">Item</th>
                <th className="pr-2 py-0.5 text-right">Client Rate</th>
                <th className="pr-2 py-0.5 text-right">−%</th>
                <th className="pr-2 py-0.5 text-right">PO Rate</th>
              </tr>
            </thead>
            <tbody>
              {lines.map((l, i) => (
                <tr key={l.po_line_uid || i} className="border-t border-violet-200" data-testid={`boqpo-rate-row-${i}`}>
                  <td className="pr-2 py-0.5 font-mono font-bold">{l.item_code}</td>
                  <td className="pr-2 py-0.5 max-w-[220px] truncate" title={l.description}>{l.description}</td>
                  <td className="pr-2 py-0.5 text-right">{inr(l.client_rate)}</td>
                  <td className="pr-2 py-0.5 text-right">{l.deduction_percent}%</td>
                  <td className="pr-2 py-0.5 text-right font-bold">{inr(l.rate)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </details>
      )}
    </div>
  );
};
